import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IUserRepository } from '../../repositories/interfaces/iUserRepository';
import { IReSubscribeOtpVerifyParams, IReSubscribeOtpVerifyResponse } from '../../../entity';
import ResponseError from '../../entities/errors/ResponseError';
import { IApiPathManager } from '../../../infrastructures/config/ApiPathManager';
import { API_IDS } from '@intigral/constant';

export interface IResubscribeOtpVerifyUseCase {
    execute(
        payload: IReSubscribeOtpVerifyParams,
        authToken: string,
        authSign: string,
        identityToken: string,
        csrfToken: { [key: string]: string }
    ): Promise<IReSubscribeOtpVerifyResponse['data']>;
}

export class ResubscribeOtpVerifyUseCase implements IResubscribeOtpVerifyUseCase {
    // Lazy getters for dependencies to avoid circular dependencies
    private get userRepo(): IUserRepository {
        return container.resolve<IUserRepository>(DI.REPOSITORIES.IUserRepository);
    }

    private get apiPathManager(): IApiPathManager {
        return container.resolve<IApiPathManager>(DI.UTILS.IApiPathManager);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(
        payload: IReSubscribeOtpVerifyParams,
        authToken: string,
        authSign: string,
        identityToken: string,
        csrfToken: { [key: string]: string }
    ): Promise<IReSubscribeOtpVerifyResponse['data']> {
        const response = await this.userRepo.resubscribeOtpVerify(
            payload,
            authToken,
            authSign,
            identityToken,
            csrfToken
        );
        if (typeof response?.error !== 'undefined') {
            const path = this.apiPathManager.getPath(API_IDS.RESUBSCRIBE_OTP_SEND);
            throw new ResponseError(
                { url: path },
                {
                    code: response.error.code || 0,
                    message: response.error?.msg || 'Unknown error',
                }
            );
        }
        return response.data;
    }
}
